var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "mb-2", attrs: { align: "center" } },
        [
          _c("v-col", [_c("h1", [_vm._v("Invoicing Rules")])]),
          _c(
            "v-col",
            { attrs: { cols: "auto" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: _vm.editMode ? "warning" : "primary",
                    outlined: ""
                  },
                  on: { click: _vm.toggleEditMode }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v(
                      _vm._s(_vm.editMode ? "mdi-pencil-off" : "mdi-pencil")
                    )
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.editMode ? "Exit edit mode" : "Edit rules") +
                      " "
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-skeleton-loader",
        {
          attrs: {
            loading: _vm.loading,
            "transition-group": "scale-transition",
            type: "table"
          }
        },
        [
          _c("InvoicingRulePanels", {
            attrs: { rules: _vm.invoicingRules, editMode: _vm.editMode },
            on: { error: _vm.showError }
          })
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { color: _vm.snackbarColor },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v(" " + _vm._s(_vm.snackbarText) + " "),
          _c(
            "v-btn",
            {
              attrs: { text: "" },
              on: {
                click: function($event) {
                  _vm.snackbar = false
                }
              }
            },
            [_vm._v(" Close ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }